/* istanbul ignore next */
export const staticSuffix = 'account'; // eslint-disable-line
export const micrositeName = 'yoda-microsite-account'; // eslint-disable-line
export const configServerSettingsFlag = true;
export const esiHeaderRequiredRoutes = null;
export const isContextHeadersRequired = true;

export const cachePolicy = {
    version: 1,
    enabled: false,
    minCache: 0,
};
export const app = {
    logTag: 'MICROSITE:ACCOUNT',
};
